const navLinks = [
  { label: "Services", href: "#services" },
  { label: "Gardens", href: "#works" },
  { label: "Our Story", href: "#about" },
  { label: "Journal", href: "#journal" },
];

import { useState } from "react";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-transparent">
      <div className="px-6 md:px-12 lg:px-16 h-20 flex items-center justify-between">
        <a
          href="#"
          className="flex items-center gap-2 cursor-pointer whitespace-nowrap"
        >
          <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-600 text-background-50">
            <i className="ri-leaf-line text-lg" />
          </span>
          <span className="font-heading text-xl tracking-tight text-foreground-950">
            Verdant
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm text-foreground-800 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#contact"
            className="px-5 py-2.5 rounded-full bg-primary-600 hover:bg-primary-700 text-background-50 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            Book a visit
          </a>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-full text-foreground-900 cursor-pointer"
          aria-label="Toggle menu"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} />
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-6 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="text-sm text-foreground-800 py-2 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="mt-2 px-5 py-2.5 rounded-full bg-primary-600 text-background-50 text-sm font-medium text-center whitespace-nowrap cursor-pointer"
          >
            Book a visit
          </a>
        </div>
      )}
    </header>
  );
}